import React from "react";
import { RuleExpectedCondition, RuleRelation } from "../../../vars";
import { deepCopy } from "../../../utils";
import SelectV2 from "../../../view/SelectV2";
import * as storeService from "../addRuleStoreService";
import ExpectedOutputField from "./ExpectedOutput";
import ExpectedConditionDropdown from "./ExpectedConditionDropdown";
import { Minus, Plus } from "lucide-react";

function Scripts({ script, index, itemsAmount, rule, disabled, onAddScriptClick, addScriptDisabled }) {

    // const conditions = [
    //     {name: 'Contains', value: RuleExpectedCondition.CONTAINS},
    //     {name: 'Not contains', value: RuleExpectedCondition.NOT_CONTAINS},
    //     {name: 'Equals', value: RuleExpectedCondition.EQUALS},
    //     {name: 'Starts with', value: RuleExpectedCondition.STARTS_WITH},
    //     {name: 'Ends with', value: RuleExpectedCondition.ENDS_WITH},
    // ]

    const conditions = script.conditions;


    const relations = [
        { name: 'And', value: RuleRelation.AND },
        { name: 'Or', value: RuleRelation.OR },
    ]
    const relationOptions = relations.map((option) => ({ value: option.value, label: option.name }));


    const onScriptChange = (script, order) => {
        const ruleCopy = deepCopy(rule);
        const index = ruleCopy.scripts.indexOf(ruleCopy.scripts.find(el => el.order === order));
        ruleCopy.scripts[index].script = script;
        storeService.changeRule(ruleCopy);
    }

    const onScriptDefinitionChange = (scriptDefinition, order) => {
        const ruleCopy = deepCopy(rule);
        const index = ruleCopy.scripts.indexOf(ruleCopy.scripts.find(el => el.order === order));
        ruleCopy.scripts[index].relation = scriptDefinition;
        storeService.changeRule(ruleCopy);
    }

    const onRemoveClick = (order) => {
        const ruleCopy = deepCopy(rule);
        const sortedScripts = ruleCopy.scripts.sort((a, b) => a.order - b.order)
        const index = sortedScripts.indexOf(sortedScripts.find(el => el.order === order));
        sortedScripts.splice(index, 1);
        sortedScripts.forEach(script => script.order = sortedScripts.indexOf(script));
        ruleCopy.scripts = sortedScripts;
        storeService.changeRule(ruleCopy);
    }

    const onAddConditionClick = () => {
        const ruleCopy = deepCopy(rule);
        // const indexScript = ruleCopy.scripts.indexOf(ruleCopy.scripts.find(el => el.order === order));
        ruleCopy.scripts[index].conditions.push(
            {
                type: RuleExpectedCondition.CONTAINS,
                order: ruleCopy.scripts[index].conditions.length,
                relation: RuleRelation.AND
            });
        storeService.changeRule(ruleCopy);
        // storeService.changeRule({
        //     ...rule,            
        //     scripts: [...script.conditions,
        //         {
        //             type: RuleExpectedCondition.CONTAINS, 
        //             order: 0, 
        //             relation: RuleRelation.AND                    
        //         }]
        // });
    }

    const onExpectedOutputChange = (output, conditionOrder) => {
        const ruleCopy = deepCopy(rule);

        const scriptIndex = ruleCopy.scripts.indexOf(ruleCopy.scripts.find(el => el.order === index));
        const conditionIndex = script.conditions.indexOf(script.conditions.find(el => el.order === conditionOrder));
        ruleCopy.scripts[scriptIndex].conditions[conditionIndex].output = output;
        storeService.changeRule(ruleCopy);
    }

    const sortedConditions = deepCopy(conditions).sort((a, b) => a.order - b.order)

    return (

        <div key={index}  className="addrules-form-stack-v2">
            {/* Script Relation — only shown for non-first scripts */}
            {index !== 0 &&
                <div className="addrules-form-group-v2">
                    <label className="addrules-form-label-v2">Script Relation</label>
                    <div className="addrules-inline-row-v2">
                        <SelectV2
                            inputId={`script-relation-${index}`}
                            className="addrules-form-select-sm-v2"
                            value={script.relation}
                            onChange={(value) => onScriptDefinitionChange(value, index)}
                            options={relationOptions}
                            isDisabled={disabled}
                        />
                    </div>
                </div>
            }

            {/* Script textarea */}
            <div className="addrules-form-group-v2">
                <label className="addrules-form-label-v2">Script</label>
                <textarea
                    className="addrules-form-textarea-v2 monospace"
                    rows="8"
                    value={script.script || ''}
                    disabled={disabled}
                    onChange={disabled ? null : event => onScriptChange(event.target.value, index)}
                />
            </div>

            {/* Remove script button — only when multiple scripts */}
            {itemsAmount > 1 &&
                <div className="addrules-script-actions-v2">
                    <button
                        className={`addrules-btn-add-v2 ${disabled ? 'disabled' : ''}`}
                        onClick={disabled ? null : () => onRemoveClick(index)}
                    >
                        <Minus />
                        Remove Script
                    </button>
                </div>
            }

            {/* Conditions */}
            {sortedConditions.map((condition, id) =>
                <div key={id} className="addrules-form-stack-v2">
                    <ExpectedConditionDropdown
                        script={script}
                        //key={index}
                        condition={condition}
                        index={condition.order}
                        itemsAmount={sortedConditions.length}
                        rule={rule}
                        disabled={disabled}
                    />

                    <ExpectedOutputField
                        data={condition}
                        //key={index}
                        onChange={(output) => onExpectedOutputChange(output, condition.order)}
                        disabled={disabled}
                    />
                </div>
            )}

            {/* Action buttons */}
            <div className="addrules-script-actions-v2 mt-4">
                <button
                    className={`addrules-btn-add-v2 ${disabled ? 'disabled' : ''}`}
                    onClick={disabled ? null : () => onAddConditionClick()}
                >
                    <Plus />
                    Add Condition
                </button>

                {onAddScriptClick && (
                    <button
                        className={`addrules-btn-add-v2 ${addScriptDisabled ? 'disabled' : ''}`}
                        onClick={addScriptDisabled ? null : () => onAddScriptClick()}
                    >
                        <Plus />
                        Add Script
                    </button>
                )}
            </div>

        </div>
    )

}

export default Scripts;
